import { Category } from "../Category.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const categoryNameMap: Record<Category, LocalizedString> = {
	[Category.CytogeneticsAndMolecularGenetics]: {
		[Locale.cs]: "Cytogenetika a molekulární biologie",
	},
	[Category.FreeRadicals]: {
		[Locale.cs]: " Výzkum biomarkerů oxidačního stresu",
	},
};
